import styled from 'styled-components';
import { BaSeTheme } from '@base/react';

export const PaddingContainer = styled.div`
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  }
`;

export const JumbotronMensagens = styled(PaddingContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;




